// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ManufacturerList_wrapper__1tHaB","boxone":"ManufacturerList_boxone__2oHJp","boxtwo":"ManufacturerList_boxtwo__1GgiY"};